import React, { useState } from "react";
import { Header, InformationMsg, List } from "./component";
import "./WeeklyTimeSheet.css";

const WeeklyTimeSheet = () => {
  const [extraFiltersState, setExtraFiltersState] = useState({
    values: {},
  });
  const [currentWeek, setCurrentWeek] = useState(null);

  return (
    <div className="wrapper-div">
      <Header 
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
        setCurrentWeek={setCurrentWeek}
      />
        
      <List 
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
        currentWeek={currentWeek}
        setCurrentWeek={setCurrentWeek}
      />
    </div>
  );
};

export default WeeklyTimeSheet;
